import {helpers} from "vuelidate/lib/validators";

export const isValidUrl = (reqProtocol) => helpers.withParams(
  { type: 'isValidUrl' },
  (value) => {
    const regexQuery = `^(https?://)${reqProtocol ? '' : '?'}(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/?[:-\\w@\\+\\.~#\\?&/=%]*)?$`
    const url = new RegExp(regexQuery, "i")
    return url.test(value.trim())
  }
)